/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { useInvoiceStore } from "../store/invoice-store";
import BilledIcon from "@/assets/icons/invoice/billed";
import PdfIcon from "@/assets/icons/invoice/pdf";
import { fileName, handleDownload } from "../helper/detail-helper";
import { useInitInvoiceDetail } from "../hooks/useInitInvoiceDetail";

const InvoiceDetailContent = styled.div`
  color: rgba(255, 255, 255, 0.65);
`;
const InvoiceDetailContentTitle = styled.div`
  background: #424242;
  color: rgba(255, 255, 255, 0.65);
  height: 36px;
  line-height: 36px;
  padding: 0 28px 0 24px;
  margin-bottom: 24px;
  margin-top: 8px;
  display: flex;
  justify-content: space-between;
`;
const InvoiceDetailContentBtn = styled.div<{ showOrderNoDetail: boolean }>`
  color: var(--main-color);
  position: relative;
  cursor: pointer;
  &:after {
    width: 6px;
    height: 6px;
    border-right: 2px solid var(--main-color);
    border-top: 2px solid var(--main-color);
    transform: ${(p) =>
      p.showOrderNoDetail ? "rotate(-45deg)" : "rotate(135deg)"};
    position: absolute;
    content: "";
    top: ${(p) => (p.showOrderNoDetail ? "16px" : "13px")};
    right: -14px;
  }
`;

const InvoiceDetailContentList = styled.div`
  padding-bottom: 16px;
  padding-left: 24px;
  display: flex;
  align-items: baseline;
  img {
    padding-right: 6px;
    height: 14px;
    margin: auto 0;
  }
`;
const InvoiceContentMultiline = styled.div`
  display: flex;
  flex-direction: column;
  word-wrap: break-word;
  max-width: calc(100% - 140px);
  padding-right: 4px;
  span:nth-child(1) {
    color: rgba(255, 255, 255, 0.85);
    line-height: 20px;
  }
  span:nth-child(2) {
    color: rgba(246, 75, 37, 0.8);
  }
`;
const InvoiceDetailDownloadUrl = styled.div`
  width: 100% !important;
  display: flex !important;
  padding-bottom: 10px;
  align-items: center;
  img {
    margin-right: 6px;
    width: 18px;
    height: 18px;
    padding: 0;
  }
  a {
    color: var(--main-color);
    padding-left: 8px;
  }
  span {
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 240px;
    color: rgba(255, 255, 255, 0.85);
    line-height: 20px;
  }
`;
const InvoiceDetailText = styled.div`
  min-width: 116px;
  display: inline-block;
  padding-right: 8px;
`;
const InvoiceDetailListAmount = styled.span`
  // background: #262729;
  margin: -16px 0 16px 0;
  color: rgba(255, 255, 255, 0.85);
  padding: 0 24px 16px 0;
  display: flex;
  flex-flow: wrap;
  border-radius: 4px;
  span {
    padding-right: 40px;
    padding: 16px 40px 0 0;
  }
`;

const InvoiceDetailListAmountWrapper = styled.div`
  display: flex;
  padding: 0 0 0 24px;
`;

export function InvoiceDetail() {
  const { t } = useTranslation("invoice");
  const [showOrderNoDetail, setShowOrderNoDetail] = useState(false);
  const [currentText, setCurrentText] = useState("invoice_detail_put_away");
  const { currentinvoiceOrderNumber, openDrawer } = useInvoiceStore();
  const { invoiceDetailInfo } = useInitInvoiceDetail();
  if (!openDrawer) return null;
  const handleOpenOrderNoDetail = () => {
    setShowOrderNoDetail(() => !showOrderNoDetail);
    setCurrentText(
      showOrderNoDetail ? "invoice_detail_expand" : "invoice_detail_put_away"
    );
  };
  return (
    <>
      {invoiceDetailInfo.map((item) => {
        return (
          <InvoiceDetailContent key={item.title}>
            <InvoiceDetailContentTitle>
              {item.title}
              {item.showHeaderIcon && (
                <InvoiceDetailContentBtn
                  showOrderNoDetail={showOrderNoDetail}
                  onClick={handleOpenOrderNoDetail}
                >
                  {t(currentText)}
                </InvoiceDetailContentBtn>
              )}
            </InvoiceDetailContentTitle>
            {item.content.map((p) => {
              return (
                <InvoiceDetailContentList key={p.text}>
                  <InvoiceDetailText>{p.text}</InvoiceDetailText>
                  {!p.showAppendixList && (
                    <>
                      <InvoiceContentMultiline>
                        <span
                          style={{
                            color: p.disableText
                              ? "rgba(255, 255, 255, 0.4)"
                              : "",
                          }}
                        >
                          {p.value}
                        </span>
                        {p.isShowChangeInvoiceHeader && (
                          <span>
                            {t("invoice_detail_change_invoice_header")}
                          </span>
                        )}
                      </InvoiceContentMultiline>
                      {p.showImgUrl && (
                        <BilledIcon style={{ marginLeft: "5px" }} />
                      )}
                    </>
                  )}
                  {p.showAppendixList &&
                    p.value &&
                    typeof p.value !== "number" &&
                    p.value.length && (
                      <div style={{ width: "auto" }}>
                        <InvoiceDetailDownloadUrl>
                          <PdfIcon />
                          <span>{fileName(p.value[0])}</span>
                          <a
                            onClick={() =>
                              handleDownload(currentinvoiceOrderNumber)
                            }
                          >
                            {t("invoice_detail_appendix_download")}
                          </a>
                        </InvoiceDetailDownloadUrl>
                      </div>
                    )}
                </InvoiceDetailContentList>
              );
            })}
            {item.showHeaderIcon &&
              showOrderNoDetail &&
              item.rechargeOrderNumberList && (
                <InvoiceDetailListAmountWrapper>
                  <div style={{ minWidth: "116px" }}>
                    {t("invoice_detail_link_orderno")}
                  </div>
                  <InvoiceDetailListAmount>
                    {item.rechargeOrderNumberList.map((orderNo) => {
                      return <span key={orderNo}>{orderNo}</span>;
                    })}
                  </InvoiceDetailListAmount>
                </InvoiceDetailListAmountWrapper>
              )}
          </InvoiceDetailContent>
        );
      })}
    </>
  );
}
